import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../Include/Header";
import { Pagination, Search } from "../../Table";
import DropDown from "../../../../Components/DropDown";
import Loader from "../../Include/Loader";
import Footer from "../../Include/Footer";
import Sidebar from "../../Include/Sidebar";
import { getAdminPMSStock } from "../../../../Store/Admin/PMS/GetPMSStock";
import moment from "moment";
import { PdfDownloadErp } from "../../../../Components/ErpPdf/PdfDownloadErp";
const PMSStock = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [limit, setlimit] = useState(10);
    const [disable, setDisable] = useState(true);

    useEffect(() => {
        if (localStorage.getItem('VA_TOKEN') === null) {
            navigate("/admin/login");
        }
        if (disable === true) {
            fetchData();
        }
    }, [navigate, disable]);

    const fetchData = () => {
        dispatch(getAdminPMSStock());
        setDisable(false);
    }

    const entity = useSelector((state) => state.getAdminPMSStock?.user?.data);

    const commentsData = useMemo(() => {
        let computedComments = entity;
        if (search) {
            computedComments = computedComments.filter(
                (st) =>
                    st.material_po_no?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    st.imir_no?.toString().toLowerCase()?.includes(search?.toLowerCase())
            );
        }
        setTotalItems(computedComments?.length);
        return computedComments?.slice(
            (currentPage - 1) * limit,
            (currentPage - 1) * limit + limit
        );
    }, [currentPage, search, limit, entity]);

    const handleRefresh = () => {
        setDisable(true);
        setSearch('');
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    const handleDownload = (options) => {
        if (options?.iselxs) {
            const bodyFormData = new URLSearchParams();
            bodyFormData.append('print_date', true);
            PdfDownloadErp({ apiMethod: 'post', url: 'stock-list-xlsx', body: bodyFormData, is_admin: true });
        } else {
            const bodyFormData = new URLSearchParams();
            bodyFormData.append('print_date', true);
            PdfDownloadErp({ apiMethod: 'post', url: `download-stock-list`, body: bodyFormData, is_admin: true });
        }
    }

    return (
        <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/user/project-store/dashboard">Dashboard </Link></li>
                                    <li className="breadcrumb-item"><i className="feather-chevron-right"></i></li>
                                    <li className="breadcrumb-item active">Stock List</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {disable === false ? (
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card card-table show-entire">
                                    <div className="card-body">

                                        <div className="page-table-header mb-2">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <div className="doctor-table-blk">
                                                        <h3>Stock List</h3>
                                                        <div className="doctor-search-blk">
                                                            <div className="top-nav-search table-search-blk">
                                                                <form>
                                                                    <Search
                                                                        onSearch={(value) => {
                                                                            setSearch(value);
                                                                            setCurrentPage(1);
                                                                        }} />

                                                                    <a className="btn"><img src="/assets/img/icons/search-normal.svg"
                                                                        alt="search" /></a>
                                                                </form>
                                                            </div>
                                                            <div className="add-group">
                                                                <button type='button' onClick={handleRefresh}
                                                                    className="btn btn-primary doctor-refresh ms-2" data-toggle="tooltip" data-placement="top" title="Refresh"><img
                                                                        src="/assets/img/icons/re-fresh.svg" alt="refresh" /></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                                                    <div className='add-group'>
                                                        <button className='btn w-100 btn btn-primary doctor-refresh me-2 h-100' type='button' onClick={() => { handleDownload({ ispdf: true }) }}> PDF <i className="fa-solid fa-download mx-2"></i></button>
                                                    </div>
                                                    <div className='add-group'>
                                                        <button className='btn w-100 btn btn-primary doctor-refresh me-2 h-100' type='button' onClick={() => { handleDownload({ iselxs: true }) }}> XLSX <i className="fa-solid fa-download mx-2"></i></button>
                                                    </div>
                                                    <DropDown limit={limit} onLimitChange={(val) => setlimit(val)} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="table-responsive">
                                            <table className="table border-0 custom-table comman-table  mb-0 datatable table-striped">
                                                <thead>
                                                    <tr>
                                                        <th className="sr_column">SR.</th>
                                                        <th>MATERIAL PO No.</th>
                                                        <th>SUPPLIER</th>
                                                        <th>MANUFACTURER</th>
                                                        <th>SECTION DETAILS</th>
                                                        <th>GRADE</th>
                                                        <th>UNIT</th>
                                                        <th>PO QTY.</th>
                                                        <th>IMIR OFF. QTY.</th>
                                                        <th>IMIR OFF. DATE</th>
                                                        <th>IMIR OFF. LENGTH(MM)</th>
                                                        <th>IMIR OFF. WIDTH(MM)</th>
                                                        <th>IMIR OFF. NOS</th>
                                                        <th>IMIR HEAT NO.</th>
                                                        <th>INSPECTION QTY(KG)</th>
                                                        <th>INSPECTION LENGTH(MM)</th>
                                                        <th>INSPECTION WIDTH(MM)</th>
                                                        <th>INSPECTION NOS</th>
                                                        <th>INSPECTION HEAT NO.</th>
                                                        <th>INSPECTION DATE</th>
                                                        <th>REJECTED QTY(KG)</th>
                                                        <th>REJECTED LENGTH(MM)</th>
                                                        <th>REJECTED WIDTH(MM)</th>
                                                        <th>IMIR NO.</th>
                                                        <th>ACTUAL QTY(KG)</th>
                                                        <th>ISSUED QTY(KG)</th>
                                                        <th>AVAILABLE QTY(KG)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {commentsData?.map((elem, i) =>
                                                        <tr key={elem?._id}>
                                                            <td className="sr_column">{(currentPage - 1) * limit + i + 1}</td>
                                                            <td>{elem?.material_po_no}</td>
                                                            <td>{elem?.mainSupplierName || '-'}</td>
                                                            <td>{elem?.manufacture || '-'}</td>
                                                            <td>{elem?.name}</td>
                                                            <td>{elem?.material_grade || '-'}</td>
                                                            <td>{elem?.unit}</td>
                                                            <td>{elem?.po_qty}</td>
                                                            <td>{(elem?.offeredQty).toFixed(2)}</td>
                                                            <td>{elem?.offer_date ? moment(elem?.offer_date).format('YYYY-MM-DD hh:mm') : '-'}</td>
                                                            <td>{elem?.offerLength || '-'}</td>
                                                            <td>{elem?.offerWidth || '-'}</td>
                                                            <td>{elem?.offerNos || '-'}</td>
                                                            <td>{elem?.lot_no || '-'}</td>

                                                            <td>{(elem?.acceptedQty)?.toFixed(2) || '-'}</td>
                                                            <td>{elem?.acceptedLength || '-'}</td>
                                                            <td>{elem?.acceptedWidth || '-'}</td>
                                                            <td>{elem?.acceptedNos || '-'}</td>
                                                            <td>{elem?.accepted_lot_no}</td>
                                                            <td>{elem.inspection_date ? moment(elem.inspection_date).format('YYYY-MM-DD hh:mm') : '-'}</td>
                                                            <td>{(elem?.rejectedQty).toFixed(2)}</td>
                                                            <td>{elem?.rejected_length}</td>
                                                            <td>{elem?.rejected_width}</td>
                                                            <td>{elem?.imir_no || '-'}</td>
                                                            <td>{(elem?.acceptedQty)?.toFixed(2) || '-'}</td>
                                                            <td>{(elem?.issued_qty)?.toFixed(2) || '-'}</td>
                                                            <td>{(elem.balance_qty)?.toFixed(2)}</td>
                                                        </tr>
                                                    )}

                                                    {commentsData?.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="999">
                                                                <div className="no-table-data">
                                                                    No Data Found!
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row align-center mt-3 mb-2">
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                                <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                                                    aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                                            </div>
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                                <div className="dataTables_paginate paging_simple_numbers"
                                                    id="DataTables_Table_0_paginate">
                                                    <Pagination
                                                        total={totalItems}
                                                        itemsPerPage={limit}
                                                        currentPage={currentPage}
                                                        onPageChange={(page) => setCurrentPage(page)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : <Loader />}
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default PMSStock;